import ContactModel from "../../model/contact.model";

export default class AvatarGenerator {
    private static avatars = {};
    private static backgrounds = [
        '#cc2222', '#cc7d22', '#ccc922', '#cc2269', '#8ecc22',
        '#22CC80', '#22C6CC', '#225DCC', '#4722CC', '#AD22CC',
        '#CC2269', '#2f4f4f', '#6495ed'
    ];

    public static generateForName(name: string, length?: number, size?: number) {
        name = name || 'Anon';
        size = size || 128;
        if(Object.keys(this.avatars).indexOf(name + '-' + length) >= 0) {
            return this.avatars[name + '-' + length];
        }
        let initials = name.split(' ').filter(e => e.trim() != '').splice(0, 2).map(n => n.substr(0, 1).toUpperCase()).join('');

        if(length === 1) {
            initials = initials.substr(0, 1);
        }
        const offset = name.split('').map(c => c.charCodeAt(0)).reduce((pv, cv) => pv + cv, 0) % AvatarGenerator.backgrounds.length;

        const canvas = document.createElement('canvas');
        const width = size;
        const height = size;
        const devicePixelRatio = Math.max(window.devicePixelRatio, 1);
        canvas.width = width * devicePixelRatio;
        canvas.height = height * devicePixelRatio;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;

        const context = canvas.getContext('2d');
        context.scale(devicePixelRatio, devicePixelRatio);
        context.rect(0, 0, canvas.width, canvas.height);
        context.fillStyle = AvatarGenerator.backgrounds[offset];
        context.fill();
        context.font = `500 ${height / 2}px '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillStyle = '#ffffff';
        context.fillText(initials, (width / 2), (height / 2 + 2));

        /* istanbul ignore next */
        this.avatars[name + '-' + length] = canvas.toDataURL('image/jpg');
        return this.avatars[name + '-' + length];
    }

    public static generateForContact(contact: ContactModel) {
        return AvatarGenerator.generateForName((contact.firstName + ' ' + contact.lastName).trim() || contact.email);
    }
}
